// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"9ebfe2a7","626":"a749d12e","745":"44e7c4bb","889":"c74aa961","959":"cdcf891e"}[chunkId] + ".chunk.js";
};